const LABELS = {
  VALIDATION_MESSAGES: {
    FETCH_ERROR: 'Dados não encontrados para o CEP informado'
  }
};

export default LABELS;
